<!--
  我的
  jay 2020-01-14
-->
<template>
  <div class="w100">
    <div class="user-top">
      <van-nav-bar class="gradient"  :fixed="false" />
      <div class="user-top-info">
        <div class="user-head">
          <img
            class="icon"
            :src="
              userInfo.avatar
                ? httpUrl + userInfo.avatar
                : require('@/assets/images/public/logo_icon@2x.png')
            "
          />
        </div>
        <div class="user-mess" @click="_linkFun('/userInfo')">
          <div class="user-name">
            <h3>{{ userInfo.nickname }}</h3>
            <span>{{ userInfo.username }}</span>
          </div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <scroll ref="scroll">
        <van-cell-group>
          <van-cell
            :title="$t('personal.messageCenter')"
            icon="icon-mess"
            is-link
            @click="_linkFun('/notice')"
          />
          <van-cell
            :title="$t('personal.myAddress')"
            icon="icon-location"
            is-link
            @click="_linkFun('/deliveryAddress')"
          />
          <van-cell
            :title="$t('personal.coupon')"
            icon="icon-ticket"
            is-link
            @click="_linkFun('/coupon')"
          />
          <van-cell
            :title="$t('personal.invitationAwards')"
            icon="icon-yaoqing"
            is-link
            @click="_linkFun('/invite')"
          />
          <van-cell
            :title="$t('personal.securitySet')"
            icon="icon-safe"
            is-link
            @click="_linkFun('/securitySet')"
          />
          <van-cell
            :title="$t('personal.commonSet')"
            icon="icon-set"
            is-link
            @click="_linkFun('/generalSet')"
          />
          <van-cell
            :title="$t('personal.versionDescription')"
            icon="icon-version"
            is-link
            @click="_linkFun('/versions')"
          />
          <van-cell
            :title="$t('personal.giveFeedback')"
            icon="icon-help"
            is-link
            @click="_linkFun('/help')"
          />
        </van-cell-group>
      </scroll>
    </div>
    <div class="button-wrap button-fixed">
      <van-button block type="primary" @click="logout">
        {{ $t("personal.quit") }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "personal",
  meta: {
    tabNav: true, // 显示菜单
    service: false // 客服
  },
  components: {},
  data() {
    return {
      active: 0
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    logout() {
      //退出
      let vm = this;
      vm.$dialog
        .confirm({
          title: "",
          message: vm.$t("personal.sureQuit")
        })
        .then(() => {
          // on confirm
          localStorage.setItem("token", "");
          vm.$store.dispatch("SET_TOKEN", "");
          vm.$store.dispatch("GET_USER_INFO", { obj: "delete" });
          vm.$router.push({
            path: "/logReg"
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.user-top {
  background: url("@{imgUrl}personal/bg_personal@2x.png") no-repeat center;
  background-size: cover;
  .gradient {
    background: transparent;
  }
  .user-top-info {
    padding: 0 20px;
    height: 130px;
    display: flex;
    align-items: center;
    .user-head {
      width: 54px;
      height: 54px;
      border-radius: 54px;
      overflow: hidden;
      margin-right: 16px;
      img {
        width: 100%;
      }
    }
    .user-mess {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      line-height: 1.5;
      h3 {
        font-size: 16px;
        font-weight: 500;
      }
      span {
        font-size: 12px;
      }
      /deep/.van-icon {
        font-size: 16px;
      }
    }
  }
}

.content-wrapper {
  top: 150px;
  bottom: 115px;
  border-radius: 18px 18px 0 0;
  overflow: hidden;
  /deep/.van-cell-group {
    .van-cell {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 15px;
      &:last-child::after {
        display: inline-block;
      }
      .van-cell__left-icon {
        width: 22px;
        height: 22px;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-size: 100%;
        &.van-icon-icon-mess {
          background-image: url("@{imgUrl}personal/icon_inform@2x.png");
        }
        &.van-icon-icon-location {
          background-image: url("@{imgUrl}personal/icon_location@2x.png");
        }
        &.van-icon-icon-ticket {
          background-image: url("@{imgUrl}personal/icon_ticket@2x.png");
        }
        &.van-icon-icon-yaoqing {
          background-image: url("@{imgUrl}personal/icon_yaoqing@2x.png");
        }
        &.van-icon-icon-safe {
          background-image: url("@{imgUrl}personal/icon_safe@2x.png");
        }
        &.van-icon-icon-set {
          background-image: url("@{imgUrl}personal/icon_setting@2x.png");
        }
        &.van-icon-icon-version {
          background-image: url("@{imgUrl}personal/icon_versions@2x.png");
        }
        &.van-icon-icon-help {
          background-image: url("@{imgUrl}personal/icon_help@2x.png");
        }
      }
    }
  }
}

.button-fixed {
  bottom: 50px;
}
</style>
